import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import {
	Heading,
	LinkBox,
	LinkOverlay,
	Text,
	SimpleGrid,
	Box,
	VStack,
	Badge,
	useColorModeValue,
} from '@chakra-ui/react'

const cards = [
	{
		href: '/game-picker',
		title: 'Picker',
		desc: 'Roll a random owned game from your BoardGameGeek collection. Filter as you want.',
		badge: 'Play',
	},
	{
		href: '/ranking-engine',
		title: 'Ranking engine',
		desc: 'Tier your collection from S to F, export the list, and revisit it anytime.',
		badge: 'Organize',
	},
]

export default function Home() {
	const homeCardBg = useColorModeValue('white', 'bgg.900')
	const homeCardBorder = useColorModeValue('blackAlpha.50', 'whiteAlpha.300')
	const homeCardShadow = useColorModeValue('sm', 'cardDark')
	const homeHoverBorder = useColorModeValue('brand.200', 'brand.400')

	return (
		<VStack spacing={10} align="stretch">
			<VStack spacing={3} align="flex-start">
				<Heading as="h1" size="lg">
					Pick the game you gonna play next. From your library.
				</Heading>
				<Text fontSize="lg" color="gray.600" maxW="lg" _dark={{ color: 'gray.300' }}>
					Use the picker to randomly choose from games you own. Or the ranking engine to tier list your collection. 
				</Text>
			</VStack>

			<SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={5}>
				{cards.map(({ href, title, desc, badge }) => (
					<LinkBox
						key={href}
						as="article"
						p={6}
						rounded="xl"
						borderWidth="1px"
						borderColor={homeCardBorder}
						bg={homeCardBg}
						boxShadow={homeCardShadow}
						transition="box-shadow 0.2s, border-color 0.2s, transform 0.2s"
						_hover={{
							boxShadow: 'md',
							borderColor: homeHoverBorder,
							transform: 'translateY(-2px)',
						}}
						textAlign="left"
					>
						<VStack align="stretch" spacing={4}>
							<Badge
								alignSelf="flex-start"
								colorScheme="brand"
								variant="subtle"
								px={2}
								py={0.5}
								rounded="md"
								fontWeight="600"
								textTransform="uppercase"
								fontSize="0.65rem"
								letterSpacing="0.08em"
							>
								{badge}
							</Badge>
							<Box>
								<Heading size="md" mb={2} color="brand.600" _dark={{ color: 'brand.300' }}>
									<LinkOverlay as={RouterLink} to={href}>
										{title}
									</LinkOverlay>
								</Heading>
								<Text color="gray.600" fontSize="sm" lineHeight="tall" _dark={{ color: 'gray.300' }}>
									{desc}
								</Text>
							</Box>
						</VStack>
					</LinkBox>
				))}
			</SimpleGrid>
		</VStack>
	)
}
